import { DEFAULT_CHART_HEIGHT } from './chart_config';
import type { ChartDataInterface } from 'src/types/Chart';

const toFiniteNumber = (value: number): number => {
	const numericValue = Number(value);
	return Number.isFinite(numericValue) ? numericValue : 0;
};

export const getDynamicChartConfig = (chartDataSet: {
	labels: string[];
	currentValues: number[];
	excludedValues: number[];
	xGrid?: boolean;
}): ChartDataInterface => {
	return {
		name: 'dynamicChart',
		type: 'bar',
		units: 'W',
		labels: chartDataSet.labels,
		loaded: chartDataSet.labels.length > 0,
		series: [
			{
				name: 'current',
				visible: true,
				data: chartDataSet.currentValues.map((value, index) => ({
					// Horizontal LayerChart bars use `dt` as their category key.
					dt: chartDataSet.labels[index] as unknown as number,
					value: toFiniteNumber(value),
				})),
				style: 'dynamicChart_current',
			},
			{
				name: 'excluded',
				visible: true,
				data: chartDataSet.excludedValues.map((value, index) => ({
					dt: chartDataSet.labels[index] as unknown as number,
					value: toFiniteNumber(value),
				})),
				style: 'dynamicChart_excluded',
			},
		],
		height: DEFAULT_CHART_HEIGHT,
		xGrid: chartDataSet.xGrid,
		logarithmic: true,
	};
};

export const getDynamicPieChartConfig = (chartDataSet: {
	labels: string[];
	keys: string[];
	currentValues: any[];
	colors: any[];
}): ChartDataInterface => {
	return {
		name: 'dynamicChart',
		type: 'pie',
		units: 'W',
		labels: chartDataSet.labels,
		keys: chartDataSet.keys,
		loaded: chartDataSet.labels.length > 0,
		series: [
			{
				name: 'dynamicChart',
				visible: true,
				data: chartDataSet.currentValues,
				colors: chartDataSet.colors,
				style: 'none',
			},
		],
		height: DEFAULT_CHART_HEIGHT,
	};
};
